import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { useTitleWhenTruncated } from '../hooks/useTitleWhenTruncated';

const ValueTagLabelRoot = styled.span`
    font-size: ${theme.fontSizes[12]};
    font-weight: ${theme.fontWeights[500]};
    line-height: 16px;
    margin: 0 ${theme.space[4]};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ValueTagLabel = ({ label, showTitle = true }: { label: string; showTitle?: boolean }) => {
    const { ref, title } = useTitleWhenTruncated<HTMLSpanElement>(label);

    return (
        <ValueTagLabelRoot ref={ref} title={showTitle ? title : undefined}>
            {label}
        </ValueTagLabelRoot>
    );
};
